import type { UpsellFlowStore } from './interfaces'

export const actions = {
  setStep (this: UpsellFlowStore, payload: UpsellFlowStore['step']): void {
    this.step = payload
  },
  reset (this: UpsellFlowStore): void {
    this.step = 'landing'
  },
  setOfferUnavailable (this: UpsellFlowStore, payload: UpsellFlowStore['offerUnavailable']): void {
    this.offerUnavailable = payload
  },
}
